import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, UploadComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-document-upload',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, TranslatePipe, UploadComponent, ButtonComponent],
	templateUrl: './document-upload.component.html',
})
export class DocumentUploadComponent {
	/**
	 * Método para obtener el documento: 'photo' | 'manual' | 'both'
	 */
	@Input() method: 'photo' | 'manual' | 'both' = 'both';

	/**
	 * Permite subida de múltiples archivos
	 */
	@Input() multiple: boolean = false;

	/**
	 * Extensiones de archivo aceptadas (ej: ['.jpg', '.png', '.pdf'])
	 */
	@Input() acceptedFileTypes: string[] = [];

	/**
	 * Label del botón de explorar
	 */
	@Input() browseButtonLabel: string = '';

	/**
	 * FormControl para el upload
	 */
	@Input() control: FormControl;

	/**
	 * Aria label para accesibilidad
	 */
	@Input() ariaLabel: string = '';

	/**
	 * Mostrar el botón de cámara basado en el método
	 */
	get showCameraButton(): boolean {
		return this.method === 'photo' || this.method === 'both';
	}

	/**
	 * Evento cuando se seleccionan archivos
	 */
	@Output() filesSelected = new EventEmitter<FileList>();

	/**
	 * Evento cuando se hace clic en el botón de cámara
	 */
	@Output() cameraClicked = new EventEmitter<void>();

	/**
	 * Maneja la selección de archivos
	 */
	onFileSelected(files: FileList): void {
		this.filesSelected.emit(files);
	}

	/**
	 * Maneja el clic en el botón de cámara
	 */
	onCameraClick(): void {
		this.cameraClicked.emit();
	}
}
